import toaster from '@/helperScripts/generalUtils/toaster';
import { BootstrapVariant } from '@/tsEnums/BootstrapVariant';
import i18n from '@/i18n';

const t = i18n.global.t;

/**
 * Copy content to clipboard and display a toast message with given title and message and an optional error message and title
 * @param content
 * @param toastTitle
 * @param toastText
 * @param toastErrTitle optional
 * @param toastErrText optional
 */
const copyToClipboardWithToast = async function (
  content,
  toastTitle: string,
  toastText: string,
  toastErrTitle?: string,
  toastErrText?: string
) {
  navigator.clipboard
    .writeText(content)
    .then(() => {
      console.log('success, copied to clipboard');
      toaster.makeToast(toastTitle, toastText, 3000, BootstrapVariant.info);
    })
    .catch(() => {
      console.log('writing to clipboard failed');
      if (toastErrText !== undefined && toastErrTitle !== undefined) {
        toaster.makeToast(
          toastErrTitle,
          toastErrText,
          3000,
          BootstrapVariant.warning
        );
      } else {
        toaster.makeToast(
          t('error.notWorked').toString(),
          t('error.copyClipboardError').toString(),
          3000,
          BootstrapVariant.warning
        );
      }
    });
};

/**
 * Copy content to clipboard
 * @param content
 */
const copyToClipboardWithoutToast = async function (newContent) {
  navigator.clipboard
    .writeText(newContent)
    .then(() => {
      console.log('success, copied to clipboard');
    })
    .catch(() => {
      console.log('writing to clipboard failed');
    });
};

export default { copyToClipboardWithToast, copyToClipboardWithoutToast };
